export { NuevoManifiestoRADEdit } from "./edit";



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/manifiestorad/nuevo/index.tsx